import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";

const VendorPaymentTable = ({
  handlePaymentClick,
  showDrawer,
  additionalData,
  pagination,
}) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )

  const openVendor = (id) => {
    navigate(`/vendorDetails?id=${id}`, {
      state: { from: "vendor_payment" }, // Pass a custom flag to track source
    });
  };

  const openOrder = (order_no) => {
    navigate(`/purchase/list`, {
      state: {
        from: "vendor_payment",
        orderId: order_no,
      },
    });
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);
  console.log("data==>", data);

  const columns = useMemo(
    () => [
      {
        Header: t("Order No."),
        accessor: "order_no",
        width: "8%",
        Cell: ({ row }) => {
          const name = row.original.order_no;
          return (
            <div
              className="truncate text-start cursor-pointer hover:underline"
              onClick={() => openOrder(name)}
              title={name}
            >
              {name}
            </div>
          );
        },
      },
      {
        Header: t("Vendor"),
        accessor: "supplier_name",
        width: "8%",
        Cell: ({ row }) => {
          const id = row.original.supplier_id;
          const name = row.original.supplier_name;
          return (
            <div
              className="truncate text-start cursor-pointer hover:underline"
              onClick={() => openVendor(id)}
              title={name}
            >
              {name}
            </div>
          );
        },
      },
      // {
      //   Header: t("Order Date & Time"),
      //   accessor: "order_date",
      //   width: "6%",
      //   Cell: ({ row }) => (
      //     <div className="truncate text-start">
      //       {row?.original?.order_date
      //         ? row?.original?.order_date.split(" ")[0]
      //         : "-"}
      //     </div>
      //   ),
      // },
      {
        Header: t("Date & Time"),
        accessor: "order_date",
        width: "10%",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {row?.original?.order_date || "-"}
          </div>
        ),
      },
      {
        Header: t("Bill No."),
        accessor: "vendor_reference",
        width: "8%",
        Cell: ({ row }) => (
          <div className="truncate text-start">
            {row.original.vendor_reference}
          </div>
        ),
      },
      {
        Header: t("Invoice Value"),
        accessor: "invoice_value",
        width: "7%",
        Cell: ({ row }) => (
          <div className="truncate text-start">
            {`EGP ${row?.original?.invoice_value?.toFixed(2)}`}
          </div>
        ),
      },
      {
        Header: t("Paid Amount"),
        accessor: "paid_amount",
        width: "7%",
        Cell: ({ row }) => (
          <div className="truncate text-start">
            {`EGP ${row.original.paid_amount?.toFixed(2)}`}
          </div>
        ),
      },
      {
        Header: t("Due Amount"),
        accessor: "due_amount",
        width: "8%",
        Cell: ({ row }) => (
          <div className="truncate text-start">
            {`EGP ${row?.original?.due_amount?.toFixed(2)}`}
          </div>
        ),
      },
      {
        Header: t("Status"),
        accessor: "status",
        width: "8%",
        Cell: ({ row }) => (
          <div className="text-start">
            <span
              className={`flex justify-center font-normal text-sm rounded-xl  ${row.original?.paid_amount > 0 && row.original?.due_amount > 0
                ? "bg-[#FFEBC5] text-[#E8A700] w-24"
                : row.original?.paid_amount === 0
                  ? "bg-[#FFEBC5] text-[#E8A700] w-24"
                  : row.original?.paid_amount > 0 &&
                    row.original?.due_amount === 0
                    ? "bg-[#D1FFDE] text-[#00B833] w-32"
                    : "text-gray-500"
                }`}
              style={{
                padding: "0.4rem 0.8rem",
              }}
            >
              {t(
                row.original?.paid_amount > 0 &&
                  row.original?.due_amount > 0 &&
                  row.original.invoice_value > 0
                  ? "Partial Payment"
                  : row.original?.paid_amount === 0 &&
                    row.original.invoice_value > 0
                    ? "Unpaid"
                    : row.original?.paid_amount > 0 &&
                      row.original?.due_amount === 0 &&
                      row.original.invoice_value > 0
                      ? "Full Payment"
                      : "Unknown Status"
              )}
            </span>
          </div>
        ),
      },

      ...(allStores
        ? [
          {
            Header: t("Store Name"),
            accessor: "store_name",
            width: "8%",
            Cell: ({ row }) => {
              // const id = row.original.supplier_id;
              const name = row.original.store_name;
              return (
                <div
                  className="text-start cursor-pointer hover:underline"
                  // onClick={() => openVendor(id)}
                  title={name}
                >
                  {name}
                </div>
              );
            },
          },
        ]
        : []),
      {
        Header: "",
        accessor: "bill_no",
        width: "16%",
        Cell: ({ row }) => (
          <div className="text-start flex">
            <button
              onClick={() => showDrawer(row.original)}
              className="font-semibold w-36 h-8 text-sm border border-primaryBlue rounded-lg bg-white text-primaryBlue flex justify-center items-center gap-2 me-3"
            >
              {t("Payment History")}
            </button>
            {!(row.original.paid_amount > 0 && row.original.due_amount === 0) &&
              row.original.invoice_value >= 0 && (
                <button
                  onClick={() => handlePaymentClick(row.original)}
                  className="font-semibold w-16 h-8 border rounded-lg bg-primaryBlue text-white text-sm flex justify-center items-center gap-2"
                  type="submit"
                >
                  {t("Pay")}
                </button>
              )}
          </div>
        ),
      },
    ],
    [t]
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);


  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                                                   {column.render("Header")}
                                                                                                                   {column.canSort && (
                                                                                                                           <span className="ms-1">
                                                                                                                     {column.isSorted ? (
                                                                                                                       column.isSortedDesc ? (
                                                                                                                         <img
                                                                                                                           src={Vectorsorting}
                                                                                                                           style={{ minHeight: 10, minWidth: 10 }}
                                                                                                                           alt="vector"
                                                                                                                         />
                                                                                                                       ) : (
                                                                                                                         <img
                                                                                                                           className="rotate-180"
                                                                                                                           src={Vectorsorting}
                                                                                                                           alt="vector"
                                                                                                                         />
                                                                                                                       )
                                                                                                                     ) : (
                                                                                                                       // 👇 Show a neutral icon when column is not sorted
                                                                                                                       <img
                                                                                                                         src={Vectorsorting}
                                                                                                                         alt="sortable"
                                                                                                                         style={{ minHeight: 10, minWidth: 10, opacity: 0.3 }}
                                                                                                                       />
                                                                                                                     )}
                                                                                                     
                                                                                                                   </span>
                                                                                                                   )}
                                                                                                                   </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "600px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div>
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex !== 1}
                canNextPage={data?.length == pageSize}
                gotoPage={(page) => nextPage(page)}
                previousPage={() => setpageIndex(pageIndex - 1)}
                nextPage={() => setpageIndex(pageIndex + 1)}
                pageSize={pageSize}
                setPageSize={(pageSize) => setPageSize(pageSize)}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default VendorPaymentTable;
